import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { EnvService } from './env.service';
import { Events } from './events.service';

@Injectable({
	providedIn: 'root'
})

export class AuthService {
	isLoggedIn = false;
	token:any;
	userid:any;
	subscription:any;

	constructor(
		private http: HttpClient,
		private env: EnvService,
		public events: Events
	) {
	}

	login(userid: String, password: String) {
		var formData: any = new FormData();
		formData.append("userid", userid);
		formData.append("userpwd", password);

		return this.http.post(this.env.API_URL + 'api/user.login.php', formData).pipe(tap(data => {
			if( data['code'] == 1000 || data['login'] == 5000 || data['login'] == 6000 )
			{
				localStorage.setItem('logiUserid', data['userid']);

				this.events.publish('user:login', {
					user: data['userid'],
					time: new Date()
				});

				return data;
				}
				else
				{
					return null;
				}
			})
		);
	}

	logout() {
		this.events.subscribe('user:logout', (data: any) => {
			user: ""
		});

		return this.http.get(this.env.API_URL + 'api/user.logout.php')
		.pipe(
			tap(data => {
				localStorage.removeItem('logiUserid');
				return data;
			})
		)
	}

	getToken(){
		var logiUserid = localStorage.getItem('logiUserid');

		if( logiUserid ){ return logiUserid; }
		else{ return false; }
	}

}